export default __webpack_public_path__ + "static/media/high-quality-image.4c0c4ac8.svg";